import { FullScreenDrawer } from '../../../../components/full-screen-drawer';
import classNames from 'classnames';
import './style.scss';
import { useEffect, useState } from 'react';
import warnImage from '../../../../assets/images/warn-yellow.png';
import {
  getServiceList,
  getAllServiceStatus,
  applyService,
  getServiceApplyInfo,
} from '../../../../api/services';
import {
  CodeServices,
  IAPIServiceConfigItem,
  IServiceApplyCreateItem,
  IServiceApplyInfo,
  IServiceStatus,
} from '../../../../model/api-modules';
import { associatedServicesData as associatedServicesJson } from '../../../game-content/service-apply/associated-service';
import subServiceIcon from '../../../../assets/svg/sub-service-icon.svg';
import alertIcon from '../../../../assets/svg/alert-icon.svg';
import { CustomPopover } from '../../../../components/custom-popover';
import getFormatMessage from '../../../../locales/get-format-message';
import Checkbox, { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { ModalWrap } from '../../../../components/modal-wrap';
import closeIcon from '../../../../assets/svg/close-icon.svg';
import { IRootState } from '../../../../store/reducers';
import { useSelector } from 'react-redux';
import { GameEnvType } from '../../../../model/api-modules/env';
import { Form, Radio, Space } from 'antd';
// import { DeployArea } from '../../../../model';
// import { getConfig } from '../../../../config';
import { getUtcTime } from '../../../../lib';
import {
  messageError,
  messageSuccess,
  messageWarning,
} from '../../../../components/message';
import { useHistory } from 'react-router-dom';
import batchApplyBg from '../../../../assets/svg/batch-apply-submit-bg.svg';
import { openContactMethod } from '../../../../lib/email';
import { ServiceShop } from './shop';
import { isVersionGreaterThan } from '../../lib';
import { isFeeEnable } from '../../../../config';

interface IProps {
  readonly visible: boolean;
  readonly onClose: () => void;
  readonly gameId: string;
  readonly envId: number;
}

enum ApplyStep {
  Select = 'Select',
  Shop = 'Shop',
  FillInfo = 'FillInfo',
  Submit = 'Submit',
}

enum SelectType {
  Parent = 'Parent',
  Service = 'Service',
  SubService = 'SubService',
}

enum ServiceStatus {
  NotOpened = 'NotOpened', // 未开通
  Applying = 'applying', // 开通中
  Opened = 'Opened', // 已开通
}

// interface IQPSItem {
//   readonly QPS: number;
//   readonly RegionID: number;
//   readonly ClusterID: number;
// }

export const BatchApplyDrawer = (props: IProps) => {
  const [step, setStep] = useState<ApplyStep>(ApplyStep.Select);
  const [serviceConfigRes, setServiceConfigRes] = useState<
    IAPIServiceConfigItem[]
  >([]);
  const [serviceConfig, setServiceConfig] = useState<
    Record<string, IAPIServiceConfigItem[]>
  >({});
  const [selectServices, setSelectServices] = useState<string[]>([]);
  const [allServiceStatus, setAllServiceStatus] = useState<Record<
    string,
    IServiceStatus[] | null
  > | null>(null);
  const [showCloseConfirm, setShowCloseConfirm] = useState<boolean>(false);
  const [needInfo, setNeedInfo] = useState<boolean>(false);
  const [selectServicesData, setSelectServicesData] = useState<
    Record<string, { name: string; subName: string[] }[]>
  >({}); // 构造后的已选服务
  // const [selectRegion, setSelectRegion] = useState<number[]>([]);
  // const [regionValues, setRegionValues] = useState<{
  //   [key: number]: number | null;
  // }>({});
  // const [pufferQpsNum, setPufferQpsNum] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [serviceApplyInfo, setServiceApplyInfo] = useState<IServiceApplyInfo[]>(
    []
  );
  const envs = useSelector((state: IRootState) => state.games.envs);
  const selectStudio = useSelector(
    (state: IRootState) => state.studio.selectStudio
  );
  const [infoForm] = Form.useForm();
  // const deployArea: DeployArea = getConfig()?.deployArea;
  // const isSingapore = deployArea === DeployArea.singapore;
  // const isWoa = deployArea === DeployArea.woa;
  // const isCn = deployArea === DeployArea.cn;
  const history = useHistory();
  const associatedServicesData = Object.assign({}, associatedServicesJson);

  useEffect(() => {
    const elements = document.getElementsByClassName('gc-console-content');
    Array.from(elements).forEach((element) => {
      if (props.visible) {
        element.classList.add('overflow-hidden');
      } else {
        element.classList.remove('overflow-hidden');
      }
    });
  }, [props.visible]);

  const serviceColor = [
    {
      name: 'Multiplayer',
      color: '#F77234',
    },
    {
      name: 'Social',
      color: '#40D4CF',
    },
    {
      name: 'Economy',
      color: '#F7BA1E',
    },
    {
      name: 'Engagement',
      color: '#F94159',
    },
    {
      name: 'Analytics',
      color: '#165DFF',
    },
    {
      name: 'Content',
      color: '#722ED1',
    },
  ];

  // const serviceRegion = [
  //   {
  //     value: 1,
  //     name: getFormatMessage('puffer_apply_southeast'),
  //     RegionID: 7101,
  //     ClusterID: 702,
  //   },
  //   {
  //     value: 2,
  //     name: getFormatMessage('puffer_apply_japan'),
  //     RegionID: 7110,
  //     ClusterID: 710,
  //   },
  //   {
  //     value: 3,
  //     name: getFormatMessage('puffer_apply_korea'),
  //     RegionID: 7111,
  //     ClusterID: 711,
  //   },
  //   {
  //     value: 4,
  //     name: getFormatMessage('puffer_apply_europe'),
  //     RegionID: 7104,
  //     ClusterID: 705,
  //   },
  //   {
  //     value: 5,
  //     name: getFormatMessage('puffer_apply_eastern'),
  //     RegionID: 7108,
  //     ClusterID: 709,
  //   },
  //   {
  //     value: 6,
  //     name: getFormatMessage('puffer_apply_western'),
  //     RegionID: 7102,
  //     ClusterID: 703,
  //   },
  //   {
  //     value: 7,
  //     name: getFormatMessage('puffer_apply_south'),
  //     RegionID: 7103,
  //     ClusterID: 704,
  //   },
  //   {
  //     value: 8,
  //     name: getFormatMessage('puffer_apply_singapore'),
  //     RegionID: 7114,
  //     ClusterID: 714,
  //   },
  // ];

  useEffect(() => {
    initServiceStatus();
  }, [props.gameId, props.envId]);

  const initServiceStatus = () => {
    getService();
    getAllServiceStatusList();
    getServiceApplyInfoList();
  };

  useEffect(() => {
    if (
      selectServices.includes('Player') ||
      selectServices.includes('Friends') ||
      selectServices.includes('Dynamic Update') ||
      selectServices.includes('Launch Update')
    ) {
      setNeedInfo(true);
    } else {
      setNeedInfo(false);
    }
  }, [selectServices]);

  const getServiceApplyInfoList = async () => {
    const res = await getServiceApplyInfo(props.gameId);
    if (res) {
      setServiceApplyInfo(res);
    }
  };

  const getAllServiceStatusList = async () => {
    const res = await getAllServiceStatus(props.gameId, props.envId);
    if (res) {
      setAllServiceStatus(res);
    }
  };

  const getService = async () => {
    const res = await getServiceList();
    if (res) {
      res.sort((a, b) => {
        const sortA = a.ParentSort;
        const sortB = b.ParentSort;
        return sortA - sortB;
      });
      setServiceConfigRes(res);
      const result: Record<string, IAPIServiceConfigItem[]> = {};
      res.forEach((item) => {
        if (item.Status !== 1) return;
        const parentName = item.ParentName;
        if (!result[parentName]) {
          result[parentName] = [];
        }

        result[parentName].push(item);
      });
      setServiceConfig(result);
    }
  };

  const renderRelevance = (name: string) => {
    let tips = '';
    const itemRelevance = associatedServicesData[name]?.relevance || [];
    if (itemRelevance.length !== 0) {
      tips = getFormatMessage('coupled_with', {
        params: {
          serviceName: itemRelevance[0],
        },
      });
    }
    if (name === 'Matchmaking') {
      tips = getFormatMessage('coupled_with', {
        params: {
          serviceName: 'DS Hosting / Gamemode & Battle / Custom Tags',
        },
      });
      // tips += `,${getFormatMessage('matchmaking_apply_tips')}`;
    }
    if (tips) {
      return (
        <CustomPopover content={tips}>
          <img
            src={alertIcon}
            style={{
              display: 'inline-block',
              width: 12,
              height: 12,
              marginTop: -2,
            }}
          />
        </CustomPopover>
      );
    }
    return null;
  };

  const onClose = async (isCloseIconClick?: boolean) => {
    if (isCloseIconClick && selectServices.length !== 0) {
      setShowCloseConfirm(true);
      return false;
    }
    props.onClose();
    setSelectServices([]);
    setShowCloseConfirm(false);
    setSelectServicesData({});
    setStep(ApplyStep.Select);
    // setPufferQpsNum(null);
    // setRegionValues({});
    // setSelectRegion([]);
    infoForm.resetFields();
    return true;
  };

  const onCancel = () => {
    if (loading) {
      return;
    }
    if (step === ApplyStep.Select) {
      if (selectServices.length !== 0) {
        setShowCloseConfirm(true);
      } else {
        onClose();
      }
    } else if (step === ApplyStep.FillInfo) {
      setSelectServicesData({});
      // setPufferQpsNum(null);
      // setRegionValues({});
      // setSelectRegion([]);
      infoForm.resetFields();
      setStep(ApplyStep.Select);
    } else if (step === ApplyStep.Shop) {
      if (needInfo) {
        setStep(ApplyStep.FillInfo);
      } else {
        setSelectServicesData({});
        setStep(ApplyStep.Select);
      }
    } else if (step === ApplyStep.Submit) {
      props.onClose();
      setSelectServices([]);
      setShowCloseConfirm(false);
      setSelectServicesData({});
      setStep(ApplyStep.Select);
      // setPufferQpsNum(null);
      // setRegionValues({});
      // setSelectRegion([]);
      infoForm.resetFields();
    }
  };

  const onNext = () => {
    if (getDisabledBtn()) {
      return;
    }
    applyOpen();
  };

  const renderSubRelevance = (name: string) => {
    let relevanceService = '';
    if (name === 'Party') {
      relevanceService = 'Party Table & Token & Gamemode';
    } else if (name === 'Lobby') {
      relevanceService = 'Lobby Table & Token & Gamemode';
    } else if (name === 'DS') {
      relevanceService = 'Battle / Custom Tags';
    } else if (name === 'Gamemode') {
      relevanceService = 'Battle / Custom Tags';
    } else if (name === 'Player Table') {
      relevanceService = 'Player';
    } else if (name === 'Party Table') {
      relevanceService = 'Party';
    } else if (name === 'Lobby Table') {
      relevanceService = 'Lobby';
    } else if (name === 'Guild Table') {
      relevanceService = 'Guild';
    } else if (name === 'BattlePass') {
      relevanceService = 'Statistics';
    }
    if (relevanceService) {
      return (
        <CustomPopover
          content={getFormatMessage('coupled_with', {
            params: {
              serviceName: relevanceService,
            },
          })}
        >
          <img
            src={alertIcon}
            style={{ display: 'inline-block', width: 12, height: 12 }}
          />
        </CustomPopover>
      );
    }
    return null;
  };

  const getSubRelevanceService = (name: string) => {
    let relevanceService = '';
    if (name === 'Party') {
      relevanceService = 'Party Table';
    } else if (name === 'Lobby') {
      relevanceService = 'Lobby Table';
    } else if (name === 'Player Table') {
      relevanceService = 'Player';
    } else if (name === 'Party Table') {
      relevanceService = 'Party';
    } else if (name === 'Lobby Table') {
      relevanceService = 'Lobby';
    } else if (name === 'Guild Table') {
      relevanceService = 'Guild';
    } else if (name === 'BattlePass') {
      relevanceService = 'Statistics';
    }
    return relevanceService;
  };

  const changeParentService = (e: CheckboxChangeEvent, name: string) => {
    const serviceList = serviceConfig[name] || [];
    setSelectServices((prev) => {
      let current = [...prev];
      serviceList.forEach((item) => {
        current = changeService(current, e, item.Name, SelectType.Service);
      });
      return current;
    });
  };

  const handleSingleChange = (
    e: CheckboxChangeEvent,
    name: string,
    type: SelectType
  ) => {
    setSelectServices((prev) => changeService(prev, e, name, type));
  };

  const changeService = (
    preSelectServices: string[],
    e: CheckboxChangeEvent,
    name: string,
    type: SelectType
  ) => {
    const currentSelect = [...preSelectServices];
    if (name === 'Dynamic Update' || name === 'Launch Update') {
      return currentSelect;
    }
    const config = serviceConfigRes.find((item) => item.Name === name);
    let itemServices = associatedServicesData[name]?.services || [];
    const env = envs.find((item) => item.id === props.envId);
    const itemGos = JSON.parse(env?.GosParams || '{}');
    if (name === 'Matchmaking') {
      if (!isVersionGreaterThan(itemGos?.GameServiceVersion)) {
        itemServices = [];
      }
    }
    if (name === 'Battle') {
      if (
        !isVersionGreaterThan(itemGos?.GameServiceVersion) &&
        !itemServices.includes('Matchmaking')
      ) {
        itemServices.push('Matchmaking');
      }
    }
    // 父服务点击事件 如果主服务已开通或正在申请则return
    if (config && allServiceStatus) {
      const configStutas = allServiceStatus[config.id];
      if (configStutas) {
        const applyingItem = configStutas.find(
          (item) => item.stage === 'applying' && item.status === 0
        );
        const openedItem = configStutas.find((item) => item.stage === 'opened');
        // 有已开通的直接return
        // if (openedItem) {
        //   return currentSelect;
        // }
        if (itemServices.length === 0) {
          // 主服务正在申请
          if (applyingItem || openedItem) {
            return currentSelect;
          }
        } else {
          let hasNotOpened = false;
          itemServices.forEach((it) => {
            const applyingSubItem = configStutas.find(
              (item) =>
                (item.stage === 'applying' || item.stage === 'opened') &&
                item.subserviceName === toLowerCaseAndRemoveSpaces(it)
            );
            if (!applyingSubItem) {
              hasNotOpened = true;
            }
          });
          // 子服务全部正在申请
          if (!hasNotOpened) {
            return currentSelect;
          }
        }
      }
    }
    const isChecked = e.target.checked;
    const itemRelevance = associatedServicesData[name]?.relevance || [];
    let relevanceService = '';
    // 主服务关联服务
    if (type === SelectType.Service) {
      if (itemRelevance.length !== 0) {
        const relevanceArr = itemRelevance[0].split('/');
        if (relevanceArr.length > 1) {
          relevanceService = relevanceArr[1].trimStart();
        } else if (relevanceArr.length === 1) {
          relevanceService = relevanceArr[0];
        }
      }
    }
    // 子服务关联服务
    if (type === SelectType.SubService) {
      relevanceService = getSubRelevanceService(name);
    }
    if (isChecked) {
      if (!currentSelect.includes(name) && itemServices.length === 0) {
        currentSelect.push(name);
      }
      // 如果当前主服务关联服务没选中则同步选中
      if (relevanceService && !currentSelect.includes(relevanceService)) {
        serviceConfigRes.forEach((item) => {
          const itemStatus = allServiceStatus
            ? allServiceStatus[item.id]
            : null;
          // 关联服务为主服务
          if (item.Name === relevanceService) {
            if (itemStatus && itemStatus.length !== 0) {
              const applyingItem = itemStatus.find(
                (item) => item.stage === 'applying' && item.status === 0
              );
              const openedItem = itemStatus.find(
                (item) => item.stage === 'opened'
              );
              if (!applyingItem && !openedItem) {
                currentSelect.push(relevanceService);
              }
            } else {
              currentSelect.push(relevanceService);
            }
          }
          if (item.SubServiceNames) {
            const subArr = item.SubServiceNames.split(',');
            subArr.forEach((it) => {
              // 关联服务为子服务
              if (it === toLowerCaseAndRemoveSpaces(relevanceService)) {
                if (itemStatus && itemStatus.length !== 0) {
                  const applyingItem = itemStatus.find(
                    (item) =>
                      (item.stage === 'applying' || item.stage === 'opened') &&
                      item.subserviceName === it
                  );
                  // const openedItem = itemStatus.find(
                  //   (item) => item.stage === 'opened'
                  // );
                  if (!applyingItem) {
                    currentSelect.push(relevanceService);
                  }
                } else {
                  currentSelect.push(relevanceService);
                }
              }
            });
          }
        });
      }
      // Party以及Lobby单向耦合Token服务以及Matchmaking / FactionSet服务
      if (
        name === 'Party' ||
        name === 'Lobby' ||
        name === 'Party Table' ||
        name === 'Lobby Table'
      ) {
        const tokenItem = serviceConfigRes.find(
          (item) => item.Name === 'Token'
        );
        if (tokenItem && allServiceStatus) {
          const tokenStatus = allServiceStatus[tokenItem.id];
          if (tokenStatus) {
            const applyingItem = tokenStatus.find(
              (item) => item.stage === 'applying' || item.stage === 'opened'
            );
            if (!applyingItem) {
              if (!currentSelect.includes('Token')) {
                currentSelect.push('Token');
              }
            }
          } else {
            if (!currentSelect.includes('Token')) {
              currentSelect.push('Token');
            }
          }
        }
        // Matchmaking低于1.12.0版本没有子服务
        const env = envs.find((item) => item.id === props.envId);
        const itemGos = JSON.parse(env?.GosParams || '{}');
        if (isVersionGreaterThan(itemGos?.GameServiceVersion)) {
          const matchmakingItem = serviceConfigRes.find(
            (item) => item.Name === 'Matchmaking'
          );
          if (matchmakingItem && allServiceStatus) {
            const matchmakingStatus = allServiceStatus[matchmakingItem.id];
            if (matchmakingStatus) {
              const applyingItem = matchmakingStatus.find(
                (item) =>
                  (item.stage === 'applying' || item.stage === 'opened') &&
                  item.subserviceName === 'factionset'
              );
              if (!applyingItem) {
                if (!currentSelect.includes('FactionSet')) {
                  currentSelect.push('FactionSet');
                }
              }
            } else {
              if (!currentSelect.includes('FactionSet')) {
                currentSelect.push('FactionSet');
              }
            }
          }
        }
      }
      // Notifications单向依赖Player Player与Player Table双向依赖
      if (name === 'Notifications') {
        const customDataItem = serviceConfigRes.find(
          (item) => item.Name === 'Custom Data'
        );
        if (customDataItem && allServiceStatus) {
          const customDataStatus = allServiceStatus[customDataItem.id];
          if (customDataStatus) {
            const applyingItem = customDataStatus.find(
              (item) =>
                (item.stage === 'applying' || item.stage === 'opened') &&
                item.subserviceName === 'playertable'
            );
            // const openedItem = customDataStatus.find(
            //   (item) => item.stage === 'opened'
            // );
            // Custom Data playertable没有处于开通中且没有已开通的子服务
            if (!applyingItem) {
              if (!currentSelect.includes('Player Table')) {
                currentSelect.push('Player Table');
              }
            }
          } else {
            if (!currentSelect.includes('Player Table')) {
              currentSelect.push('Player Table');
            }
          }
        }
      }
      // Matchmaking单向耦合DS Hosting / Gamemode、Battle / CustomTags服务
      if (name === 'Matchmaking') {
        const dsItem = serviceConfigRes.find(
          (item) => item.Name === 'DS Hosting'
        );
        if (dsItem && allServiceStatus) {
          const dsStatus = allServiceStatus[dsItem.id];
          if (dsStatus) {
            const applyingItem = dsStatus.find(
              (item) =>
                (item.stage === 'applying' || item.stage === 'opened') &&
                item.subserviceName === 'gamemode'
            );
            if (!applyingItem) {
              if (!currentSelect.includes('Gamemode')) {
                currentSelect.push('Gamemode');
              }
            }
          } else {
            if (!currentSelect.includes('Gamemode')) {
              currentSelect.push('Gamemode');
            }
          }
        }
        const battleItem = serviceConfigRes.find(
          (item) => item.Name === 'Battle'
        );
        if (battleItem && allServiceStatus) {
          const battleStatus = allServiceStatus[battleItem.id];
          if (battleStatus) {
            const applyingItem = battleStatus.find(
              (item) =>
                (item.stage === 'applying' || item.stage === 'opened') &&
                item.subserviceName === 'customtags'
            );
            if (!applyingItem) {
              if (!currentSelect.includes('Custom Tags')) {
                currentSelect.push('Custom Tags');
              }
            }
          } else {
            if (!currentSelect.includes('Custom Tags')) {
              currentSelect.push('Custom Tags');
            }
          }
        }
      }
      if (itemServices.length !== 0) {
        itemServices.forEach((serItem) => {
          if (!currentSelect.includes(serItem)) {
            const itemConfig = serviceConfigRes.find(
              (item) => item.Name === name
            );
            if (itemConfig) {
              const itemStatus = allServiceStatus
                ? allServiceStatus[itemConfig.id]
                : null;
              if (itemStatus && itemStatus.length !== 0) {
                const applyingItem = itemStatus.find(
                  (item) =>
                    (item.stage === 'applying' || item.stage === 'opened') &&
                    item.subserviceName === toLowerCaseAndRemoveSpaces(serItem)
                );
                // const openedItem = itemStatus.find(
                //   (item) => item.stage === 'opened'
                // );
                if (!applyingItem) {
                  currentSelect.push(serItem);
                }
              } else {
                currentSelect.push(serItem);
              }
            }
          }
          const subRelevanceService = getSubRelevanceService(serItem);
          // 如果当前子服务关联服务没选中则同步选中
          if (
            subRelevanceService &&
            !currentSelect.includes(subRelevanceService)
          ) {
            serviceConfigRes.forEach((item) => {
              const itemStatus = allServiceStatus
                ? allServiceStatus[item.id]
                : null;
              // 关联服务为主服务
              if (item.Name === subRelevanceService) {
                if (itemStatus && itemStatus.length !== 0) {
                  const applyingItem = itemStatus.find(
                    (item) => item.stage === 'applying' && item.status === 0
                  );
                  const openedItem = itemStatus.find(
                    (item) => item.stage === 'opened'
                  );
                  if (!applyingItem && !openedItem) {
                    currentSelect.push(subRelevanceService);
                  }
                } else {
                  currentSelect.push(subRelevanceService);
                }
              }
              if (item.SubServiceNames) {
                const subArr = item.SubServiceNames.split(',');
                subArr.forEach((it) => {
                  // 关联服务为子服务
                  if (it === toLowerCaseAndRemoveSpaces(subRelevanceService)) {
                    if (itemStatus && itemStatus.length !== 0) {
                      const applyingItem = itemStatus.find(
                        (item) =>
                          (item.stage === 'applying' ||
                            item.stage === 'opened') &&
                          item.subserviceName === it
                      );
                      // const openedItem = itemStatus.find(
                      //   (item) => item.stage === 'opened'
                      // );
                      if (!applyingItem) {
                        currentSelect.push(subRelevanceService);
                      }
                    } else {
                      currentSelect.push(subRelevanceService);
                    }
                  }
                });
              }
            });
          }
          if (
            serItem === 'Party' ||
            serItem === 'Lobby' ||
            serItem === 'Party Table' ||
            serItem === 'Lobby Table'
          ) {
            if (!currentSelect.includes('Token')) {
              const tokenItem = serviceConfigRes.find(
                (item) => item.Name === 'Token'
              );
              if (tokenItem && allServiceStatus) {
                const tokenStatus = allServiceStatus[tokenItem.id];
                if (tokenStatus) {
                  const applyingItem = tokenStatus.find(
                    (item) =>
                      item.stage === 'applying' || item.stage === 'opened'
                  );
                  if (!applyingItem) {
                    if (!currentSelect.includes('Token')) {
                      currentSelect.push('Token');
                    }
                  }
                } else {
                  if (!currentSelect.includes('Token')) {
                    currentSelect.push('Token');
                  }
                }
              }
            }
            const env = envs.find((item) => item.id === props.envId);
            const itemGos = JSON.parse(env?.GosParams || '{}');
            if (isVersionGreaterThan(itemGos?.GameServiceVersion)) {
              if (!currentSelect.includes('FactionSet')) {
                const matchmakingItem = serviceConfigRes.find(
                  (item) => item.Name === 'Matchmaking'
                );
                if (matchmakingItem && allServiceStatus) {
                  const matchmakingStatus =
                    allServiceStatus[matchmakingItem.id];
                  if (matchmakingStatus) {
                    const applyingItem = matchmakingStatus.find(
                      (item) =>
                        (item.stage === 'applying' ||
                          item.stage === 'opened') &&
                        item.subserviceName === 'factionset'
                    );
                    if (!applyingItem) {
                      if (!currentSelect.includes('FactionSet')) {
                        currentSelect.push('FactionSet');
                      }
                    }
                  } else {
                    if (!currentSelect.includes('FactionSet')) {
                      currentSelect.push('FactionSet');
                    }
                  }
                }
              }
            }
          }
        });
      }

      if (currentSelect.includes('Party') || currentSelect.includes('Lobby')) {
        const dsItem = serviceConfigRes.find(
          (item) => item.Name === 'DS Hosting'
        );
        if (dsItem && allServiceStatus) {
          const dsStatus = allServiceStatus[dsItem.id];
          if (dsStatus) {
            const applyingItem = dsStatus.find(
              (item) =>
                (item.stage === 'applying' || item.stage === 'opened') &&
                item.subserviceName === 'gamemode'
            );
            if (!applyingItem) {
              if (!currentSelect.includes('Gamemode')) {
                currentSelect.push('Gamemode');
              }
            }
          } else {
            if (!currentSelect.includes('Gamemode')) {
              currentSelect.push('Gamemode');
            }
          }
        }
        const battleItem = serviceConfigRes.find(
          (item) => item.Name === 'Battle'
        );
        if (battleItem && allServiceStatus) {
          const battleStatus = allServiceStatus[battleItem.id];
          if (battleStatus) {
            const applyingItem = battleStatus.find(
              (item) =>
                (item.stage === 'applying' || item.stage === 'opened') &&
                item.subserviceName === 'customtags'
            );
            if (!applyingItem) {
              if (!currentSelect.includes('Custom Tags')) {
                currentSelect.push('Custom Tags');
              }
            }
          } else {
            if (!currentSelect.includes('Custom Tags')) {
              currentSelect.push('Custom Tags');
            }
          }
        }
      }
      if (currentSelect.includes('Custom Tags')) {
        const dsItem = serviceConfigRes.find(
          (item) => item.Name === 'DS Hosting'
        );
        if (dsItem && allServiceStatus) {
          const dsStatus = allServiceStatus[dsItem.id];
          if (dsStatus) {
            const applyingItem = dsStatus.find(
              (item) =>
                (item.stage === 'applying' || item.stage === 'opened') &&
                item.subserviceName === 'gamemode'
            );
            if (!applyingItem) {
              if (!currentSelect.includes('Gamemode')) {
                currentSelect.push('Gamemode');
              }
            }
          } else {
            if (!currentSelect.includes('Gamemode')) {
              currentSelect.push('Gamemode');
            }
          }
        }
      }
      if (currentSelect.includes('DS') || currentSelect.includes('Gamemode')) {
        const battleItem = serviceConfigRes.find(
          (item) => item.Name === 'Battle'
        );
        if (battleItem && allServiceStatus) {
          const battleStatus = allServiceStatus[battleItem.id];
          if (battleStatus) {
            const applyingItem = battleStatus.find(
              (item) =>
                (item.stage === 'applying' || item.stage === 'opened') &&
                item.subserviceName === 'customtags'
            );
            if (!applyingItem) {
              if (!currentSelect.includes('Custom Tags')) {
                currentSelect.push('Custom Tags');
              }
            }
          } else {
            if (!currentSelect.includes('Custom Tags')) {
              currentSelect.push('Custom Tags');
            }
          }
        }
      }
      if (currentSelect.includes('DS') && !currentSelect.includes('Gamemode')) {
        const dsItem = serviceConfigRes.find(
          (item) => item.Name === 'DS Hosting'
        );
        if (dsItem && allServiceStatus) {
          const dsStatus = allServiceStatus[dsItem.id];
          if (dsStatus) {
            const applyingItem = dsStatus.find(
              (item) =>
                (item.stage === 'applying' || item.stage === 'opened') &&
                item.subserviceName === 'gamemode'
            );
            if (!applyingItem) {
              currentSelect.push('Gamemode');
            }
          } else {
            currentSelect.push('Gamemode');
          }
        }
      }
    } else {
      if (currentSelect.includes(name)) {
        currentSelect.splice(currentSelect.indexOf(name), 1);
      }
      // 如果当前关联服务选中则同步取消选中
      if (relevanceService && currentSelect.includes(relevanceService)) {
        // 单向依赖特殊处理
        if (
          name !== 'BattlePass' &&
          name !== 'Notifications' &&
          name !== 'Battle'
        ) {
          currentSelect.splice(currentSelect.indexOf(relevanceService), 1);
        }
      }
      // Notifications单向依赖Player
      if (name === 'Player' && currentSelect.includes('Notifications')) {
        currentSelect.splice(currentSelect.indexOf('Notifications'), 1);
      }
      // BattlePass单向依赖Statistics
      if (name === 'Statistics' && currentSelect.includes('BattlePass')) {
        currentSelect.splice(currentSelect.indexOf('BattlePass'), 1);
      }
      // Player与Player Table双向依赖   Notifications单向依赖Player
      if (name === 'Player Table' && currentSelect.includes('Notifications')) {
        currentSelect.splice(currentSelect.indexOf('Notifications'), 1);
      }
      // Party以及Lobby单向依赖Token   Party以及Lobby分别与Party Table和Lobby Table双向依赖
      if (name === 'Token') {
        if (currentSelect.includes('Party')) {
          currentSelect.splice(currentSelect.indexOf('Party'), 1);
        }
        if (currentSelect.includes('Lobby')) {
          currentSelect.splice(currentSelect.indexOf('Lobby'), 1);
        }
        if (currentSelect.includes('Party Table')) {
          currentSelect.splice(currentSelect.indexOf('Party Table'), 1);
        }
        if (currentSelect.includes('Lobby Table')) {
          currentSelect.splice(currentSelect.indexOf('Lobby Table'), 1);
        }
      }
      // Party以及Lobby单向依赖FactionSet   Party以及Lobby分别与Party Table和Lobby Table双向依赖
      if (name === 'Matchmaking') {
        if (currentSelect.includes('FactionSet')) {
          if (currentSelect.includes('Party')) {
            currentSelect.splice(currentSelect.indexOf('Party'), 1);
          }
          if (currentSelect.includes('Lobby')) {
            currentSelect.splice(currentSelect.indexOf('Lobby'), 1);
          }
          if (currentSelect.includes('Party Table')) {
            currentSelect.splice(currentSelect.indexOf('Party Table'), 1);
          }
          if (currentSelect.includes('Lobby Table')) {
            currentSelect.splice(currentSelect.indexOf('Lobby Table'), 1);
          }
        }
      }
      if (
        ((name === 'Party' || name === 'Party Table') &&
          !currentSelect.includes('Lobby')) ||
        ((name === 'Lobby' || name === 'Lobby Table') &&
          !currentSelect.includes('Party'))
      ) {
        if (
          !currentSelect.includes('Matchmaker') &&
          !currentSelect.includes('SkillRating')
        ) {
          if (currentSelect.includes('FactionSet')) {
            // 如果Party和Lobby同时不选中，且Matchmaking没有选中，则自动取消FactionSet
            currentSelect.splice(currentSelect.indexOf('FactionSet'), 1);
          }
        }
      }
      if (itemServices.length !== 0) {
        itemServices.forEach((item) => {
          if (currentSelect.includes(item)) {
            currentSelect.splice(currentSelect.indexOf(item), 1);
          }
          const subRelevanceService = getSubRelevanceService(item);
          // 如果当前子服务关联服务选中则同步取消选中
          if (
            subRelevanceService &&
            currentSelect.includes(subRelevanceService)
          ) {
            if (item !== 'BattlePass') {
              currentSelect.splice(
                currentSelect.indexOf(subRelevanceService),
                1
              );
            }
          }
          // Player与Player Table双向依赖   Notifications单向依赖Player
          if (
            item === 'Player Table' &&
            currentSelect.includes('Notifications')
          ) {
            currentSelect.splice(currentSelect.indexOf('Notifications'), 1);
          }
        });
      }

      if (
        !currentSelect.includes('Custom Tags') &&
        selectServices.includes('Custom Tags')
      ) {
        if (currentSelect.includes('Gamemode')) {
          currentSelect.splice(currentSelect.indexOf('Gamemode'), 1);
        }
      }
      // 当前没有Gamemode而更改前的数据有Gamemode则代表取消了Gamemode选中
      if (
        !currentSelect.includes('Gamemode') &&
        selectServices.includes('Gamemode')
      ) {
        if (currentSelect.includes('Party')) {
          currentSelect.splice(currentSelect.indexOf('Party'), 1);
        }
        if (currentSelect.includes('Lobby')) {
          currentSelect.splice(currentSelect.indexOf('Lobby'), 1);
        }
        if (currentSelect.includes('Party Table')) {
          currentSelect.splice(currentSelect.indexOf('Party Table'), 1);
        }
        if (currentSelect.includes('Lobby Table')) {
          currentSelect.splice(currentSelect.indexOf('Lobby Table'), 1);
        }
        if (currentSelect.includes('Matchmaking')) {
          currentSelect.splice(currentSelect.indexOf('Matchmaking'), 1);
        }
      }
      if (
        !currentSelect.includes('Gamemode') &&
        selectServices.includes('Gamemode')
      ) {
        if (currentSelect.includes('DS')) {
          currentSelect.splice(currentSelect.indexOf('DS'), 1);
        }
      }
      if (
        !currentSelect.includes('Gamemode') &&
        !currentSelect.includes('DS') &&
        (selectServices.includes('Gamemode') || selectServices.includes('DS'))
      ) {
        if (currentSelect.includes('Custom Tags')) {
          currentSelect.splice(currentSelect.indexOf('Custom Tags'), 1);
        }
      }
    }
    return currentSelect;
  };

  const getCheckboxClass = (
    serviceStatus: ServiceStatus,
    isParent?: boolean
  ) => {
    let checkboxClass = '';
    if (serviceStatus === ServiceStatus.Applying) {
      checkboxClass = 'checkbox-applying';
    } else if (serviceStatus === ServiceStatus.Opened) {
      checkboxClass = isParent
        ? 'checkbox-opened parent-bg'
        : 'checkbox-opened';
    }
    return checkboxClass;
  };

  // 小写去空格
  const toLowerCaseAndRemoveSpaces = (str: string) => {
    return str.toLowerCase().replace(/\s+/g, '');
  };

  const getFormInit = () => {
    const applyInfo: Record<string, any> = {};
    if (selectServices.includes('Player')) {
      const configItem = serviceConfigRes.find(
        (item) => item.Name === 'Player'
      );
      const applyInfoItem = serviceApplyInfo.find((item) => {
        const applyInfoData = JSON.parse(item.ApplyInfo || '{}');
        return (
          item.ServiceID === configItem?.id &&
          Object.keys(applyInfoData).length !== 0
        );
      });
      if (applyInfoItem) {
        const applyInfoData = JSON.parse(applyInfoItem.ApplyInfo || '{}');
        applyInfo.whether_name_unique = applyInfoData.whether_name_unique || 1;
        applyInfo.whether_query_by_name =
          applyInfoData.whether_query_by_name || 1;
      } else {
        applyInfo.whether_name_unique = 1;
        applyInfo.whether_query_by_name = 1;
      }
    }
    if (selectServices.includes('Friends')) {
      const configItem = serviceConfigRes.find(
        (item) => item.Name === 'Friends'
      );
      const applyInfoItem = serviceApplyInfo.find((item) => {
        const applyInfoData = JSON.parse(item.ApplyInfo || '{}');
        return (
          item.ServiceID === configItem?.id &&
          Object.keys(applyInfoData).length !== 0
        );
      });
      if (applyInfoItem) {
        const applyInfoData = JSON.parse(applyInfoItem.ApplyInfo || '{}');
        applyInfo.friend_type = applyInfoData.friend_type || 1;
      } else {
        applyInfo.friend_type = 1;
      }
    }
    return applyInfo;
  };

  // const onRegionChange = (checkedValues: any) => {
  //   setSelectRegion(checkedValues);
  //   // 去除取消选中的地区值
  //   const newRegionValues: { [key: number]: number | null } = {};
  //   checkedValues.forEach((item: number) => {
  //     newRegionValues[item] = regionValues[item];
  //   });
  //   setRegionValues(newRegionValues);
  // };

  // const onQpsChange = (value: number | null, region: number) => {
  //   setRegionValues((prevValues) => ({
  //     ...prevValues,
  //     [region]: value,
  //   }));
  // };

  // const getPufferDisabled = () => {
  //   if (
  //     selectServices.includes('Dynamic Update') ||
  //     selectServices.includes('Launch Update')
  //   ) {
  //     if (isSingapore) {
  //       let isDisabled = false;
  //       if (step === ApplyStep.FillInfo) {
  //         if (selectRegion.length === 0) {
  //           isDisabled = true;
  //         }
  //         selectRegion.forEach((item) => {
  //           if (!regionValues[item]) {
  //             isDisabled = true;
  //           }
  //         });
  //       }
  //       return isDisabled;
  //     }
  //     if (!pufferQpsNum && step === ApplyStep.FillInfo) {
  //       return true;
  //     }
  //   }
  //   return false;
  // };

  const getApplyInfoDisabled = (name: string) => {
    let isDisabled = false;
    if (name !== 'DMP') {
      const configItem = serviceConfigRes.find((item) => item.Name === name);
      const applyInfoItem = serviceApplyInfo.find((item) => {
        const applyInfoData = JSON.parse(item.ApplyInfo || '{}');
        return (
          item.ServiceID === configItem?.id &&
          Object.keys(applyInfoData).length !== 0
        );
      });
      if (applyInfoItem) {
        return (isDisabled = true);
      }
    } else {
      const configDynamicItem = serviceConfigRes.find(
        (item) => item.Name === 'Dynamic Update'
      );
      const configLaunchItem = serviceConfigRes.find(
        (item) => item.Name === 'Launch Update'
      );
      const applyInfoItem = serviceApplyInfo.find((item) => {
        const applyInfoData = JSON.parse(item.ApplyInfo || '{}');
        return (
          (item.ServiceID === configDynamicItem?.id ||
            item.ServiceID === configLaunchItem?.id) &&
          Object.keys(applyInfoData).length !== 0
        );
      });
      if (applyInfoItem) {
        return (isDisabled = true);
      }
    }
    return isDisabled;
  };

  const renderStepContent = () => {
    if (step === ApplyStep.Select) {
      const serviceKeys = Object.keys(serviceConfig);
      return (
        <div className="step-select">
          <div className="step-select-tips">
            <img src={warnImage} />
            <span>{getFormatMessage('coupling_tips')}</span>
          </div>
          {serviceKeys.length !== 0 && (
            <div className="step-select-content">
              {serviceKeys.map((item, index) => {
                const serviceList = serviceConfig[item] || [];
                let allOpened = true;
                let anyOpening = false;
                let anyNotOpened = false;
                let canCheckCount = 0; // 可以勾选的服务数量
                let checkedCount = 0; // 当前勾选的服务数量
                serviceList.forEach((serviceItem) => {
                  if (
                    serviceItem.Name !== 'Dynamic Update' &&
                    serviceItem.Name !== 'Launch Update'
                  ) {
                    const itemStatus = allServiceStatus
                      ? allServiceStatus[serviceItem.id]
                      : null;
                    const itemService = Object.assign(
                      [],
                      associatedServicesData[serviceItem.Name]?.services || []
                    );

                    const env = envs.find((item) => item.id === props.envId);
                    const itemGos = JSON.parse(env?.GosParams || '{}');
                    // 旧版本Matchmaking为Battle子服务
                    if (!isVersionGreaterThan(itemGos?.GameServiceVersion)) {
                      if (serviceItem?.Name === 'Battle') {
                        if (!itemService.includes('Matchmaking')) {
                          itemService.push('Matchmaking');
                        }
                      }
                      if (serviceItem?.Name === 'Matchmaking') {
                        return;
                      }
                    }
                    if (serviceItem?.Name === 'Battle') {
                      if (
                        isVersionGreaterThan(itemGos?.GameServiceVersion) &&
                        itemService.includes('Matchmaking')
                      ) {
                        itemService.splice(
                          itemService.indexOf('Matchmaking'),
                          1
                        );
                      }
                    }
                    if (itemStatus) {
                      if (itemService.length === 0) {
                        const openedItem = itemStatus.find(
                          (it) => it.stage === 'opened'
                        );
                        const applyingItem = itemStatus.find(
                          (it) => it.stage === 'applying' && it.status === 0
                        );
                        if (!openedItem) {
                          allOpened = false;
                          if (applyingItem) {
                            anyOpening = true;
                          } else {
                            anyNotOpened = true;
                            canCheckCount += 1;
                            if (selectServices.includes(serviceItem.Name)) {
                              checkedCount += 1;
                            }
                          }
                        }
                      } else {
                        itemService.forEach((serviceIt) => {
                          const openedItem = itemStatus.find(
                            (it) =>
                              it.stage === 'opened' &&
                              it.subserviceName ===
                                toLowerCaseAndRemoveSpaces(serviceIt)
                          );
                          const applyingItem = itemStatus.find(
                            (it) =>
                              it.stage === 'applying' &&
                              it.status === 0 &&
                              it.subserviceName ===
                                toLowerCaseAndRemoveSpaces(serviceIt)
                          );
                          if (!openedItem) {
                            allOpened = false;
                            if (applyingItem) {
                              anyOpening = true;
                            } else {
                              anyNotOpened = true;
                              canCheckCount += 1;
                              if (selectServices.includes(serviceIt)) {
                                checkedCount += 1;
                              }
                            }
                          }
                        });
                      }
                    } else {
                      allOpened = false;
                      anyNotOpened = true;
                      if (itemService.length === 0) {
                        canCheckCount += 1;
                        if (selectServices.includes(serviceItem.Name)) {
                          checkedCount += 1;
                        }
                      } else {
                        itemService.forEach((serviceIt) => {
                          canCheckCount += 1;
                          if (selectServices.includes(serviceIt)) {
                            checkedCount += 1;
                          }
                        });
                      }
                    }
                  }
                });

                let parentServiceStatus = ServiceStatus.NotOpened;
                if (allOpened) {
                  parentServiceStatus = ServiceStatus.Opened;
                } else if (anyOpening && !anyNotOpened) {
                  parentServiceStatus = ServiceStatus.Applying;
                }
                return (
                  <div
                    className={classNames(
                      'step-select-content-item',
                      index === serviceKeys.length - 1 ? 'none-border' : ''
                    )}
                  >
                    <div className="content-item-name">
                      <Checkbox
                        onChange={(e) => changeParentService(e, item)}
                        className={getCheckboxClass(parentServiceStatus, true)}
                        indeterminate={
                          checkedCount > 0 && checkedCount < canCheckCount
                        }
                        checked={
                          (checkedCount > 0 &&
                            checkedCount === canCheckCount) ||
                          parentServiceStatus !== ServiceStatus.NotOpened
                        }
                        disabled={
                          parentServiceStatus !== ServiceStatus.NotOpened
                        }
                      >
                        {item}
                      </Checkbox>
                    </div>
                    <div className="content-item-services-box">
                      {serviceList.length !== 0 &&
                        serviceList.map((serviceItem) => {
                          // if (
                          //   serviceItem.Name === 'Dynamic Update' ||
                          //   serviceItem.Name === 'Launch Update'
                          // ) {
                          //   return (<CustomPopover content={getFormatMessage('not_support_dmp')}>
                          //     <Checkbox
                          //             className={getCheckboxClass(
                          //               serviceStatus
                          //             )}
                          //             checked={true}
                          //             disabled={true}
                          //           >
                          //             {serviceItem.Name}
                          //           </Checkbox>
                          //   </CustomPopover>);
                          // }
                          const itemService = Object.assign(
                            [],
                            associatedServicesData[serviceItem.Name]
                              ?.services || []
                          );
                          const env = envs.find(
                            (item) => item.id === props.envId
                          );
                          const itemGos = JSON.parse(env?.GosParams || '{}');
                          // Matchmaking低于1.12.0版本没有子服务
                          if (serviceItem.Name === 'Matchmaking') {
                            if (
                              !isVersionGreaterThan(itemGos?.GameServiceVersion)
                            ) {
                              // itemService = [];
                              return null;
                            }
                          }
                          if (serviceItem.Name === 'Battle') {
                            if (
                              !isVersionGreaterThan(
                                itemGos?.GameServiceVersion
                              ) &&
                              !itemService.includes('Matchmaking')
                            ) {
                              itemService.push('Matchmaking');
                            }
                            if (
                              isVersionGreaterThan(
                                itemGos?.GameServiceVersion
                              ) &&
                              itemService.includes('Matchmaking')
                            ) {
                              itemService.splice(
                                itemService.indexOf('Matchmaking'),
                                1
                              );
                            }
                          }
                          let subSelectNum = 0;
                          itemService.length !== 0 &&
                            itemService.forEach((subItem) => {
                              if (selectServices.includes(subItem)) {
                                subSelectNum += 1;
                              }
                            });
                          let serviceStatus = ServiceStatus.NotOpened;
                          const statusItem = allServiceStatus
                            ? allServiceStatus[serviceItem.id]
                            : null;
                          // 申请中的子项
                          const subApplying: string[] = [];
                          // 已开通的子项
                          const subOpened: string[] = [];
                          let canCheckedSub = 0;
                          if (statusItem && statusItem.length !== 0) {
                            // 没有子服务的主服务处理
                            if (itemService.length === 0) {
                              const applyingItem = statusItem.find(
                                (it) =>
                                  it.status === 0 && it.stage === 'applying'
                              );
                              // 停服也算已开通
                              const openedItem = statusItem.find(
                                (it) => it.stage === 'opened'
                              );
                              // 正在开通中
                              if (applyingItem && !openedItem) {
                                serviceStatus = ServiceStatus.Applying;
                              }
                              // 服务已开通
                              if (openedItem) {
                                serviceStatus = ServiceStatus.Opened;
                              }
                            } else {
                              itemService.forEach((subitem) => {
                                const applyingItem = statusItem.find(
                                  (it) =>
                                    it.status === 0 &&
                                    it.stage === 'applying' &&
                                    it.subserviceName ===
                                      toLowerCaseAndRemoveSpaces(subitem)
                                );
                                const openedItem = statusItem.find(
                                  (it) =>
                                    it.stage === 'opened' &&
                                    it.subserviceName ===
                                      toLowerCaseAndRemoveSpaces(subitem)
                                );
                                if (applyingItem && !openedItem) {
                                  subApplying.push(subitem);
                                }
                                if (openedItem) {
                                  subOpened.push(subitem);
                                }
                                if (!applyingItem && !openedItem) {
                                  canCheckedSub += 1;
                                }
                              });
                              if (
                                subApplying.length === itemService.length &&
                                subOpened.length === 0
                              ) {
                                serviceStatus = ServiceStatus.Applying;
                              }
                              if (subOpened.length !== 0) {
                                serviceStatus = ServiceStatus.Opened;
                              }
                            }
                          } else {
                            if (itemService.length !== 0) {
                              canCheckedSub += itemService.length;
                            }
                          }
                          if (
                            serviceItem.Name === 'Dynamic Update' ||
                            serviceItem.Name === 'Launch Update'
                          ) {
                            return (
                              <CustomPopover
                                content={getFormatMessage('not_support_dmp')}
                              >
                                <Checkbox
                                  className={getCheckboxClass(serviceStatus)}
                                  checked={
                                    serviceStatus !== ServiceStatus.NotOpened
                                  }
                                  disabled={true}
                                >
                                  {serviceItem.Name}
                                </Checkbox>
                              </CustomPopover>
                            );
                          }
                          return (
                            <div className="service-item-box">
                              <div className="service-item">
                                {serviceStatus === ServiceStatus.Applying ? (
                                  <CustomPopover
                                    content={getFormatMessage(
                                      'service_application_tips'
                                    )}
                                  >
                                    <Checkbox
                                      className={getCheckboxClass(
                                        serviceStatus
                                      )}
                                      checked={true}
                                      disabled={true}
                                    >
                                      {serviceItem.Name}
                                    </Checkbox>
                                  </CustomPopover>
                                ) : (
                                  <Checkbox
                                    className={getCheckboxClass(serviceStatus)}
                                    onChange={(e) =>
                                      handleSingleChange(
                                        e,
                                        serviceItem.Name,
                                        SelectType.Service
                                      )
                                    }
                                    indeterminate={
                                      subSelectNum > 0 &&
                                      subSelectNum < canCheckedSub
                                    }
                                    checked={
                                      (subSelectNum > 0 &&
                                        subSelectNum === canCheckedSub) ||
                                      (subSelectNum === 0 &&
                                        selectServices.includes(
                                          serviceItem.Name
                                        )) ||
                                      serviceStatus !== ServiceStatus.NotOpened
                                    }
                                    disabled={
                                      serviceStatus !== ServiceStatus.NotOpened
                                    }
                                  >
                                    {serviceItem.Name}
                                  </Checkbox>
                                )}
                                {renderRelevance(serviceItem.Name)}
                              </div>
                              {itemService.length !== 0 &&
                                itemService.map((it) => {
                                  return (
                                    <div className="sub-service-item">
                                      <img src={subServiceIcon} />
                                      {subApplying.includes(it) ? (
                                        <CustomPopover
                                          content={getFormatMessage(
                                            'service_application_tips'
                                          )}
                                        >
                                          <Checkbox
                                            className={getCheckboxClass(
                                              ServiceStatus.Applying
                                            )}
                                            checked={true}
                                            disabled={true}
                                          >
                                            {it}
                                          </Checkbox>
                                        </CustomPopover>
                                      ) : (
                                        <Checkbox
                                          className={getCheckboxClass(
                                            subOpened.includes(it)
                                              ? ServiceStatus.Opened
                                              : ServiceStatus.NotOpened
                                          )}
                                          onChange={(e) =>
                                            handleSingleChange(
                                              e,
                                              it,
                                              SelectType.SubService
                                            )
                                          }
                                          disabled={
                                            subOpened.includes(it) ||
                                            serviceItem.Name === 'Matchmaking'
                                          }
                                          checked={
                                            selectServices.includes(it) ||
                                            subOpened.includes(it)
                                          }
                                        >
                                          {it}
                                        </Checkbox>
                                      )}
                                      {renderSubRelevance(it)}
                                    </div>
                                  );
                                })}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      );
    }
    if (step === ApplyStep.FillInfo) {
      const parentKeys = Object.keys(selectServicesData);
      // let dmpTips = '';
      // if (selectServices.includes('Dynamic Update')) {
      //   dmpTips += 'Dynamic Update';
      // }
      // if (selectServices.includes('Launch Update')) {
      //   dmpTips += dmpTips.length === 0 ? 'Launch Update' : '/Launch Update';
      // }
      return (
        <div className="step-info">
          <div className="step-info-services">
            {getFormatMessage('select_apply_service')}
          </div>
          {parentKeys.map((item) => {
            const data = selectServicesData[item];
            const serviceArr: string[] = [];
            data.forEach((it) => {
              if (it.subName?.length !== 0) {
                const subService = it.subName.join('/');
                serviceArr.push(`${it.name}(${subService})`);
              } else {
                serviceArr.push(it.name);
              }
            });
            const showService = serviceArr.join('、');
            const color =
              serviceColor.find((it) => it.name === item)?.color || '#000000';
            const r = parseInt(color.slice(1, 3), 16);
            const g = parseInt(color.slice(3, 5), 16);
            const b = parseInt(color.slice(5, 7), 16);
            return (
              <div className="step-info-services-item">
                <div
                  className="step-info-services-item-parent"
                  style={{ color, background: `rgba(${r}, ${g}, ${b}, 0.1)` }}
                >
                  {item}
                </div>
                <div className="step-info-services-item-service">
                  {showService}
                </div>
              </div>
            );
          })}
          <Form
            form={infoForm}
            className="batch-services-info-form"
            initialValues={getFormInit()}
          >
            {selectServices.includes('Player') && (
              <div>
                <div className="batch-services-info-form-title">{`Player ${getFormatMessage(
                  'related_matters_fill'
                )}`}</div>
                <Form.Item
                  label={getFormatMessage('whether_name_unique_label')}
                  name="whether_name_unique"
                  colon={false}
                >
                  <Radio.Group
                    defaultValue={1}
                    disabled={getApplyInfoDisabled('Player')}
                  >
                    <Space direction="vertical">
                      {getApplyInfoDisabled('Player') ? (
                        <CustomPopover
                          content={getFormatMessage('no_re_submission_tips')}
                        >
                          <Radio value={1}>{getFormatMessage('yes')}</Radio>
                        </CustomPopover>
                      ) : (
                        <Radio value={1}>{getFormatMessage('yes')}</Radio>
                      )}
                      {getApplyInfoDisabled('Player') ? (
                        <CustomPopover
                          content={getFormatMessage('no_re_submission_tips')}
                        >
                          <Radio value={-1}>{getFormatMessage('no')}</Radio>
                        </CustomPopover>
                      ) : (
                        <Radio value={-1}>{getFormatMessage('no')}</Radio>
                      )}
                    </Space>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  label={getFormatMessage('whether_query_by_name_label')}
                  name="whether_query_by_name"
                  colon={false}
                >
                  <Radio.Group
                    defaultValue={1}
                    disabled={getApplyInfoDisabled('Player')}
                  >
                    <Space direction="vertical">
                      {getApplyInfoDisabled('Player') ? (
                        <CustomPopover
                          content={getFormatMessage('no_re_submission_tips')}
                        >
                          <Radio value={1}>{getFormatMessage('yes')}</Radio>
                        </CustomPopover>
                      ) : (
                        <Radio value={1}>{getFormatMessage('yes')}</Radio>
                      )}
                      {getApplyInfoDisabled('Player') ? (
                        <CustomPopover
                          content={getFormatMessage('no_re_submission_tips')}
                        >
                          <Radio value={-1}>{getFormatMessage('no')}</Radio>
                        </CustomPopover>
                      ) : (
                        <Radio value={-1}>{getFormatMessage('no')}</Radio>
                      )}
                    </Space>
                  </Radio.Group>
                </Form.Item>
              </div>
            )}
            {selectServices.includes('Friends') && (
              <div>
                <div className="batch-services-info-form-title">{`Friends ${getFormatMessage(
                  'related_matters_fill'
                )}`}</div>
                <Form.Item
                  label={getFormatMessage('friend_type_label')}
                  name="friend_type"
                  colon={false}
                >
                  <Radio.Group
                    defaultValue={1}
                    disabled={getApplyInfoDisabled('Friends')}
                  >
                    <Space direction="vertical">
                      {getApplyInfoDisabled('Friends') ? (
                        <CustomPopover
                          content={getFormatMessage('no_re_submission_tips')}
                        >
                          <Radio value={1}>
                            {getFormatMessage('account_friends')}
                          </Radio>
                        </CustomPopover>
                      ) : (
                        <Radio value={1}>
                          {getFormatMessage('account_friends')}
                        </Radio>
                      )}
                      {getApplyInfoDisabled('Friends') ? (
                        <CustomPopover
                          content={getFormatMessage('no_re_submission_tips')}
                        >
                          <Radio value={2}>
                            {getFormatMessage('character_friends')}
                          </Radio>
                        </CustomPopover>
                      ) : (
                        <Radio value={2}>
                          {getFormatMessage('character_friends')}
                        </Radio>
                      )}
                    </Space>
                  </Radio.Group>
                </Form.Item>
              </div>
            )}
            {/* {(selectServices.includes('Dynamic Update') ||
              selectServices.includes('Launch Update')) && (
                <div>
                  <div className="batch-services-info-form-title">{`${dmpTips} ${getFormatMessage(
                    'related_matters_fill'
                  )}`}</div>
                  {isSingapore ? (
                    <Form.Item
                      label={getFormatMessage('puffer_apply_region')}
                      name="Region"
                    >
                      <Checkbox.Group onChange={onRegionChange} disabled={getApplyInfoDisabled('DMP')}>
                        <Space direction="vertical">
                          {serviceRegion.map((item) => {
                            return (
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  lineHeight: '30px',
                                }}
                              >
                                <Checkbox value={item.value}>
                                  {item.name}
                                </Checkbox>
                                {selectRegion.includes(item.value) && (
                                  <InputNumber
                                    width={300}
                                    min={1}
                                    precision={0}
                                    formatter={(value) => {
                                      let newVal = value;
                                      if (value && value < 1) {
                                        newVal = 1;
                                      }
                                      return `${newVal}`.replace(/\D/g, '');
                                    }}
                                    placeholder={getFormatMessage(
                                      'qps_placeholder'
                                    )}
                                    onChange={(value) =>
                                      onQpsChange(value, item.value)
                                    }
                                    disabled={getApplyInfoDisabled('DMP')}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </Space>
                      </Checkbox.Group>
                    </Form.Item>
                  ) : (
                    <Form.Item
                      label={getFormatMessage('qps_label')}
                      name="QPS"
                    // colon={false}
                    >
                      <InputNumber
                        min={1}
                        precision={0}
                        formatter={(value) => {
                          let newVal = value;
                          if (value && value < 1) {
                            newVal = 1;
                          }
                          return `${newVal}`.replace(/\D/g, '');
                        }}
                        onChange={(value) => setPufferQpsNum(value)}
                        placeholder={getFormatMessage('qps_placeholder')}
                        disabled={getApplyInfoDisabled('DMP')}
                      />
                    </Form.Item>
                  )}
                </div>
              )} */}
          </Form>
        </div>
      );
    }
    if (step === ApplyStep.Shop) {
      return <ServiceShop />;
    }
    return null;
  };

  const getDisabledBtn = () => {
    let isDisabled = false;
    if (step === ApplyStep.Select) {
      if (selectServices.length === 0) {
        isDisabled = true;
      }
    }
    return isDisabled || loading;
  };

  const getOkText = () => {
    if (step === ApplyStep.Select) {
      return getFormatMessage('apply_next_btn');
    }
    if (step === ApplyStep.FillInfo) {
      if (getIsVoiceService()) {
        return getFormatMessage('apply_next_btn');
      }
      return getFormatMessage('apply_submit_btn');
    }
    if (step === ApplyStep.Shop) {
      return getFormatMessage('service_apply_estimate');
    }
    return '';
  };

  const renderFooter = () => {
    if (step !== ApplyStep.Submit) {
      return (
        <div className="footer-btn">
          <div className="btn-cancel" onClick={onCancel}>
            {step === ApplyStep.Select
              ? getFormatMessage('cancel')
              : getFormatMessage('apply_back_btn')}
          </div>
          <div
            className={classNames(
              'btn-next',
              getDisabledBtn() ? 'btn-disabled' : ''
            )}
            onClick={onNext}
          >
            {getOkText()}
          </div>
          {step === ApplyStep.Shop && (
            <div className="shop-tips">
              {getFormatMessage('order_pay_by_quantity_tips')}
            </div>
          )}
        </div>
      );
    }
    return null;
  };

  const renderCloseConfirmModal = () => {
    if (showCloseConfirm) {
      return (
        <ModalWrap
          title={getFormatMessage('exit_apply')}
          cancelText={getFormatMessage('cancel')}
          oKText={getFormatMessage('confirm')}
          onClose={() => setShowCloseConfirm(false)}
          onOk={onClose}
        >
          <div>{getFormatMessage('exit_apply_tips')}</div>
        </ModalWrap>
      );
    }
  };

  const getSubmitStep = () => {
    let submitStep = 2;
    if (needInfo) {
      submitStep += 1;
    }
    if (getIsVoiceService()) {
      submitStep += 1;
    }
    return submitStep;
  };

  const getIsVoiceService = () => {
    const envItem = envs.find((item) => item.id === props.envId);
    const hasVoice = selectServices.find((item) =>
      /^voice\s+chat$/i.test(item)
    );
    return isFeeEnable() && envItem?.Type === GameEnvType.Live && hasVoice;
  };
  // const getHasDmp = () => {
  //     let isHas = false;
  //     serviceConfigRes.forEach(item => {
  //         if (item.Business === ServiceBusiness.DMP) {
  //             isHas = true;
  //         }
  //     });
  //     return isHas;
  // };

  const jumpToOrderPage = (orderID: string) => {
    if (!selectStudio) {
      return;
    }

    history.push(
      `/studio/${selectStudio.studioID}/fee/order-result/${orderID}`
    );
  };

  const applyOpen = async () => {
    const isVoiceService = getIsVoiceService();

    const currentData: Record<string, { name: string; subName: string[] }[]> =
      Object.assign({}, selectServicesData);
    if (step === ApplyStep.Select) {
      selectServices.forEach((item) => {
        const configItem = serviceConfigRes.find((it) => it.Name === item);
        const env = envs.find((item) => item.id === props.envId);
        const itemGos = JSON.parse(env?.GosParams || '{}');
        let isOldMatch = false;
        if (
          !isVersionGreaterThan(itemGos?.GameServiceVersion) &&
          item === 'Matchmaking'
        ) {
          isOldMatch = true;
        }
        // 1.12.0以下旧版本Matchmaking还是battle的子服务
        if (configItem && !isOldMatch) {
          // 主服务处理
          if (!currentData[configItem.ParentName]) {
            currentData[configItem.ParentName] = [];
          }
          currentData[configItem.ParentName].push({
            name: configItem.Name,
            subName: [],
          });
        } else {
          // 子服务处理
          const configSubItem = serviceConfigRes.find((it) => {
            const subNameArr = it.SubServiceNames?.split(',') || [];
            return subNameArr.includes(toLowerCaseAndRemoveSpaces(item));
          });
          if (configSubItem) {
            if (!currentData[configSubItem.ParentName]) {
              currentData[configSubItem.ParentName] = [];
            }
            const subItem = currentData[configSubItem.ParentName].find(
              (it) => it.name === configSubItem.Name
            );
            if (!subItem) {
              currentData[configSubItem.ParentName].push({
                name: configSubItem.Name,
                subName: [item],
              });
            } else {
              if (!subItem.subName) {
                subItem.subName = [];
              }
              subItem.subName.push(item);
            }
          }
        }
      });
      setSelectServicesData(currentData);
      if (needInfo) {
        setStep(ApplyStep.FillInfo);
        return false;
      }
      if (isVoiceService) {
        setStep(ApplyStep.Shop);
        return false;
      }
    }
    if (step === ApplyStep.FillInfo && isVoiceService) {
      setStep(ApplyStep.Shop);
      return false;
    }
    const values = await infoForm.validateFields();
    setLoading(true);
    try {
      const parentKeys = Object.keys(currentData);
      const servicesBody: Record<string, IServiceApplyCreateItem> = {};
      parentKeys.forEach((item) => {
        currentData[item].forEach((it) => {
          const itemConfig = serviceConfigRes.find(
            (configIt) => configIt.Name === it.name
          );
          if (itemConfig) {
            const subName: string[] = [];
            let applyInfo = '';
            if (it.subName.length !== 0) {
              it.subName.forEach((subIt) => {
                subName.push(toLowerCaseAndRemoveSpaces(subIt));
              });
            }
            if (it.name === 'Player') {
              applyInfo = JSON.stringify({
                whether_name_unique: values.whether_name_unique,
                whether_query_by_name: values.whether_query_by_name,
              });
            } else if (it.name === 'Friends') {
              applyInfo = JSON.stringify({
                friend_type: values.friend_type,
              });
            }
            // DMP不支持批量
            // else if (
            //   it.name === 'Dynamic Update' ||
            //   it.name === 'Launch Update'
            // ) {
            //   const newValues: IQPSItem[] = [];
            //   if (isSingapore) {
            //     selectRegion.forEach((item) => {
            //       const regionItem = serviceRegion.find(
            //         (it) => it.value === item
            //       );
            //       const qpsItem = regionValues[item];
            //       if (regionItem && qpsItem) {
            //         newValues.push({
            //           QPS: qpsItem,
            //           RegionID: regionItem.RegionID,
            //           ClusterID: regionItem.ClusterID,
            //         });
            //       }
            //     });
            //   }
            //   if (isWoa) {
            //     newValues.push({
            //       QPS: values.QPS,
            //       RegionID: 2100,
            //       ClusterID: 200,
            //     });
            //   }
            //   if (isCn) {
            //     newValues.push({
            //       QPS: values.QPS,
            //       RegionID: 4100,
            //       ClusterID: 410,
            //     });
            //   }
            //   applyInfo = JSON.stringify(newValues);
            // }
            servicesBody[itemConfig.id] = {
              applyInfo,
              isRelation: false,
              serviceID: itemConfig.id,
              subName,
            };
          }
        });
      });
      const applyBody = {
        serviceItems: servicesBody,
        toLink: `${location.origin}/admin/service`,
        gameID: props.gameId,
        envID: props.envId, // 如果需要dmp批量还需额外处理
        applyTime: getUtcTime(new Date()),
      };
      const res: any = await applyService(applyBody);
      let repetitionServices = '';
      switch (res.code) {
        case CodeServices.CurrentServiceApproval:
          initServiceStatus();
          if (res.data?.applying && res.data.applying.length !== 0) {
            res.data.applying.forEach((item: any) => {
              if (item.SubServiceName) {
                if (repetitionServices.length === 0) {
                  repetitionServices += item.SubServiceName;
                } else {
                  repetitionServices += `,${item.SubServiceName}`;
                }
              }
            });
          }
          messageWarning(
            getFormatMessage('application_already_sent', {
              params: {
                services: repetitionServices,
              },
            })
          );
          break;
        case CodeServices.UserApplyOpenedServiceNotFound:
          messageWarning(getFormatMessage('service_not_exist'));
          break;
        case CodeServices.NotExistToApprovalURL:
          messageError(getFormatMessage('apply_service_fail'));
          break;
        case CodeServices.CompanyAuthNotComplete:
          messageWarning(getFormatMessage('company_not_valid'));
          break;
        default:
          messageSuccess(getFormatMessage('application_sent_success'));
          initServiceStatus();
          if (isVoiceService) {
            jumpToOrderPage(res.data?.[0]);
            return true;
          }
          setStep(ApplyStep.Submit);
      }
    } catch (err: any) {
      if (err?.apiError?.code === 101803) {
        messageSuccess(getFormatMessage('application_sent_success'));
        initServiceStatus();
      } else if (err?.apiError?.code === 101846) {
        messageError(getFormatMessage('company_status_error_warn'));
      } else {
        messageError(getFormatMessage('apply_service_fail'));
      }
    }
    setLoading(false);
    return true;
  };

  const renderContent = (): React.ReactNode => {
    if (step === ApplyStep.Submit) {
      return (
        <div className="batch-apply-submit">
          <img src={batchApplyBg} className="submit-success-bg-icon" />
          <div className="submit-success-tips">
            {getFormatMessage('batch_apply_submit_tips')}
          </div>
          <div className="submit-success-contact">
            <span onClick={(event) => openContactMethod(event)}>
              {getFormatMessage('contact_us')}
            </span>
          </div>
          <div className="submit-success-complete" onClick={onCancel}>
            {getFormatMessage('apply_complete_btn')}
          </div>
        </div>
      );
    }
    return (
      <div className="batch-apply-page">
        <div className="batch-apply-header-box">
          <div className="batch-apply-header-content">
            <div className="header-ingame">InGame</div>
            <div className="header-service-open">
              <span>{getFormatMessage('apply_to_start')}</span>
            </div>
            <div className="header-step">
              <div className="header-step-item">
                <div
                  className={classNames(
                    'header-step-item-left',
                    step === ApplyStep.Select ? 'header-step-item-active' : ''
                  )}
                >
                  1
                </div>
                <div className="header-step-item-right">
                  <div className="header-step-item-right-top">Step1</div>
                  <div className="header-step-item-right-bottom">
                    {getFormatMessage('service_selection')}
                  </div>
                </div>
              </div>
              {needInfo && (
                <div className="header-step-item">
                  <div className="header-step-item-line"></div>
                  <div
                    className={classNames(
                      'header-step-item-left',
                      step === ApplyStep.FillInfo
                        ? 'header-step-item-active'
                        : ''
                    )}
                  >
                    2
                  </div>
                  <div className="header-step-item-right">
                    <div className="header-step-item-right-top">Step2</div>
                    <div className="header-step-item-right-bottom">
                      {getFormatMessage('information_filling')}
                    </div>
                  </div>
                </div>
              )}
              {getIsVoiceService() && (
                <div className="header-step-item">
                  <div className="header-step-item-line"></div>
                  <div
                    className={classNames(
                      'header-step-item-left',
                      step === ApplyStep.Shop ? 'header-step-item-active' : ''
                    )}
                  >
                    {needInfo ? 3 : 2}
                  </div>
                  <div className="header-step-item-right">
                    <div className="header-step-item-right-top">{`Step${
                      needInfo ? 3 : 2
                    }`}</div>
                    <div className="header-step-item-right-bottom">
                      {getFormatMessage('service_shop')}
                    </div>
                  </div>
                </div>
              )}
              <div className="header-step-item">
                <div className="header-step-item-line"></div>
                <div className="header-step-item-left">{getSubmitStep()}</div>
                <div className="header-step-item-right">
                  <div className="header-step-item-right-top">{`Step${getSubmitStep()}`}</div>
                  <div className="header-step-item-right-bottom">
                    {getIsVoiceService()
                      ? getFormatMessage('service_apply_estimate')
                      : getFormatMessage('submit_applications')}
                  </div>
                </div>
              </div>
            </div>
            <img
              src={closeIcon}
              className="header-close-icon"
              onClick={() => onClose(true)}
            />
          </div>
        </div>
        {renderStepContent()}
        {renderFooter()}
        {renderCloseConfirmModal()}
      </div>
    );
  };
  return (
    <FullScreenDrawer renderContent={renderContent} visible={props.visible} />
  );
};
